
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91catch_45categories_45or_45content_93RmFF9q1kaSMeta } from "/opt/buildhome/repo/pages/[catch-categories-or-content].vue?macro=true";
import { default as indexrvgTzVDF2PMeta } from "/opt/buildhome/repo/pages/announcement/[category]/[detail]/index.vue?macro=true";
import { default as indexTHUtqNnf1hMeta } from "/opt/buildhome/repo/pages/announcement/[category]/index.vue?macro=true";
import { default as index0HYgKiCvfpMeta } from "/opt/buildhome/repo/pages/announcement/index.vue?macro=true";
import { default as indexYe7Le438P8Meta } from "/opt/buildhome/repo/pages/categories/[detail]/index.vue?macro=true";
import { default as index6yDS2Nat0aMeta } from "/opt/buildhome/repo/pages/categories/index.vue?macro=true";
import { default as indexGPn8pSu59jMeta } from "/opt/buildhome/repo/pages/content/[detail]/index.vue?macro=true";
import { default as indexwuE9EcDQIUMeta } from "/opt/buildhome/repo/pages/dictionary/[detail]/index.vue?macro=true";
import { default as indexLLeB1Zzf4FMeta } from "/opt/buildhome/repo/pages/dictionary/index.vue?macro=true";
import { default as indexCMVanMCzFOMeta } from "/opt/buildhome/repo/pages/index/index.vue?macro=true";
import { default as indexQxlpTD49gXMeta } from "/opt/buildhome/repo/pages/search/index.vue?macro=true";
import { default as language_45preferences0FzYXk5wGRMeta } from "/opt/buildhome/repo/pages/settings/language-preferences.vue?macro=true";
import { default as indexgM36QU3hrXMeta } from "/opt/buildhome/repo/pages/status/[detail]/index.vue?macro=true";
import { default as indexxdxm7XqCs1Meta } from "/opt/buildhome/repo/pages/status/index.vue?macro=true";
export default [
  {
    name: "catchcategoriesorcontent",
    path: "/:catchcategoriesorcontent()",
    component: () => import("/opt/buildhome/repo/pages/[catch-categories-or-content].vue")
  },
  {
    name: "announcement-category-detail",
    path: "/announcement/:category()/:detail()",
    meta: indexrvgTzVDF2PMeta || {},
    component: () => import("/opt/buildhome/repo/pages/announcement/[category]/[detail]/index.vue")
  },
  {
    name: "announcement-category",
    path: "/announcement/:category()",
    meta: indexTHUtqNnf1hMeta || {},
    component: () => import("/opt/buildhome/repo/pages/announcement/[category]/index.vue")
  },
  {
    name: "announcement",
    path: "/announcement",
    meta: index0HYgKiCvfpMeta || {},
    component: () => import("/opt/buildhome/repo/pages/announcement/index.vue")
  },
  {
    name: "categories-detail",
    path: "/categories/:detail()",
    meta: indexYe7Le438P8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/categories/[detail]/index.vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: index6yDS2Nat0aMeta || {},
    component: () => import("/opt/buildhome/repo/pages/categories/index.vue")
  },
  {
    name: "content-detail",
    path: "/content/:detail()",
    meta: indexGPn8pSu59jMeta || {},
    component: () => import("/opt/buildhome/repo/pages/content/[detail]/index.vue")
  },
  {
    name: "dictionary-detail",
    path: "/dictionary/:detail()",
    meta: indexwuE9EcDQIUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/dictionary/[detail]/index.vue")
  },
  {
    name: "dictionary",
    path: "/dictionary",
    meta: indexLLeB1Zzf4FMeta || {},
    component: () => import("/opt/buildhome/repo/pages/dictionary/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexCMVanMCzFOMeta || {},
    component: () => import("/opt/buildhome/repo/pages/index/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indexQxlpTD49gXMeta || {},
    component: () => import("/opt/buildhome/repo/pages/search/index.vue")
  },
  {
    name: "settings-language-preferences",
    path: "/settings/language-preferences",
    meta: language_45preferences0FzYXk5wGRMeta || {},
    component: () => import("/opt/buildhome/repo/pages/settings/language-preferences.vue")
  },
  {
    name: "status-detail",
    path: "/status/:detail()",
    meta: indexgM36QU3hrXMeta || {},
    component: () => import("/opt/buildhome/repo/pages/status/[detail]/index.vue")
  },
  {
    name: "status",
    path: "/status",
    meta: indexxdxm7XqCs1Meta || {},
    component: () => import("/opt/buildhome/repo/pages/status/index.vue")
  }
]